"use strict";

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var address_1 = require("@celo/base/lib/address");

exports.NULL_ADDRESS = address_1.NULL_ADDRESS;

var address_registry_1 = require("./address-registry");

exports.REGISTRY_CONTRACT_ADDRESS = address_registry_1.REGISTRY_CONTRACT_ADDRESS;

var base_1 = require("./base");

exports.AllContracts = base_1.AllContracts;
exports.CeloContract = base_1.CeloContract;
exports.RegisteredContracts = base_1.RegisteredContracts;

var celo_tokens_1 = require("./celo-tokens");

exports.CeloTokens = celo_tokens_1.CeloTokens;
exports.StableToken = celo_tokens_1.StableToken;
exports.Token = celo_tokens_1.Token;

var identity_1 = require("./identity");

exports.IdentityMetadataWrapper = identity_1.IdentityMetadataWrapper;

__export(require("./kit"));

__export(require("./proxy"));